import { FormattedMessage, injectIntl } from 'react-intl';
import React, {
  useState,
  useContext,
  useEffect,
  useRef,
  useCallback,
  useImperativeHandle,
} from 'react';
import { Form, Input, Spin, Row, Col, Skeleton, Button, Checkbox } from 'antd';
import moment from 'moment';
import classnames from 'classnames';
import { LoadingOutlined } from '@ant-design/icons';
import FloatLabel from '@/components/H5PC/Form/FloatLabel/index.js';
import Email from '@/components/H5PC/Form/Email';
import getTypeByPattern from '@/components/Common/getTypeByPattern.js';
import { infoCb } from '@/service';
import _ from 'lodash';
import NodeRSA from 'node-rsa';
import { getDomainFromUrlStr, getDomainStr } from '@/components/H5PC/utils'
import CPF from '@/components/H5PC/Components/CPF';
import myContext from '@/utils/createContext';
import { getUrlParams, gtag, arraysHaveCommonValues } from '@/utils/index.js';
import Address from '@/components/H5PC/Form/Address';

const FormItem = Form.Item;

const key = getUrlParams('key'); // 从 URL 中获取 key

function PIXBOL(props) {
  const nameOnCardRef = useRef();
  const addressRef = useRef();
  const intl = props.intl;
  const { formatMessage } = intl;
  // radioValue 即为LCR 或者 ICR
  const { form, initData, resData, cashierData, radioValue, isMobileView, type, loading, setLoading, actualPaymentAmount,
    actualPaymentCurrency, supportBirthDate } = useContext(
    myContext,
    );
  console.log(cashierData, 'cashierData', type);
  const h5OrWeb = isMobileView ? 'H5' : 'WEB';
  let showDomain = '';
  if(typeof window!= 'undefined' && getDomainFromUrlStr()){
    showDomain = getDomainStr(resData)
  }
  let [activeLoading, setActiveLoading] = useState(true);

  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [hasTerms, setHasTerms] = useState(false);

  useEffect(() => {
    if (!_.isEmpty(cashierData)) {
      setTimeout(() => {
        setActiveLoading(false);
      }, 10);
      // 判断是否需要显示条款
      const payments = cashierData?.payments;

      payments.map((item, key) => { 
        if (item?.paymentMethod === type.toUpperCase() && arraysHaveCommonValues(['Llbr-pix', 'Llbr-boleto'], item?.channelCodes)) { 
          setHasTerms(true)
        }
      })
    }
    setButtonDisabled(sessionStorage.getItem('buttonDisabled') === 'true' ? true : false)
  }, [cashierData]);

  // 生日回显：生日框是条件挂载（shouldUpdate 跟 CPF 11 位），未挂载时
  // setFieldsValue 会被 antd 丢弃，所以不能在 fetchInitData 里回显。
  // 此处等 initData 到位 + CPF 已回显成 11 位，生日框挂载后再写 birthDate。
  // 后端 paymentInfoData.dateOfBirth 经 getPaymentData 展开进 initData，
  // 格式 YYYY-MM-DD，转 DD/MM/YYYY 展示。解析失败当无预填，不写脏值。
  // fetchInitData 里 getCardNo 在 setInitData 之前同步执行，故 initData 变化时 CPF 已在 form。
  useEffect(() => {
    const raw = initData?.dateOfBirth;
    if (!raw) return;
    const cpfDigits = String(form.getFieldValue('cardHolderIdNo') || '').replace(/[^0-9]/g, '');
    if (cpfDigits.length !== 11) return;
    const m = moment(raw, 'YYYY-MM-DD', true);
    if (!m.isValid()) return;
    form.setFieldsValue({ birthDate: m.format('DD/MM/YYYY') });
  }, [initData]);
  const onBlurCardName = async function(e) {
    gtag(`${showDomain}支付页面`, [new Date() + '输入持卡人姓名']);
    gtag(`${showDomain}支付页面`, ['输入持卡人姓名']);
    showDomain ? gtag(`定制支付页面`, ['输入持卡人姓名']):'';
    
  };
  // todo 111，专门传递address组件中的信息而存在的
  useImperativeHandle(props.cref, () => ({
    // 动态改变label的值
    clickEdit: () => {
      setAddressChange(addressRef);
    },
  }));

  // 表单验证错误，弹出地址选择信息
  const setAddressChange = cref => {
    if (!_.isEmpty(cref.current)) {
      cref.current.clickEdit();
    }
  };
  // todo 222，专门传递address组件中的信息而存在的

  return (
    <Skeleton
      loading={activeLoading}
      active={true}
      title={false}
      // style={{ padding: 100 }}
      paragraph={{ rows: 7 }}
    >
      {radioValue === 'PIX' || radioValue === 'BOL' ? (
        <>
          <Row gutter={20} style={{ marginBottom: '-10px', padding: '0 15px' }}>
            <Col span={24}>
              <FloatLabel
                extra={<div style={{ marginBottom: form.getFieldValue('cardName')? 0 : 16}}>{formatMessage({ id: 'ga-checkout.new-full-name-extraTip' })}</div>}
                form={form}
                name="cardName"
                cref={nameOnCardRef}
                // label="Full Name"
                //formatMessage({ id: 'ga-checkout.sailor-payer-name' })
                label={cashierData?.merchantSourceType === "SAILOR"?formatMessage({ id: 'ga-checkout.sailor-payer-name' }):formatMessage({ id: 'ga-checkout.new-full-name' })}
                rules={[
                  {
                    required: true,
                    // message: `Please enter your full name.`,
                    message: cashierData?.merchantSourceType === "SAILOR"?formatMessage({ id: 'ga-checkout.sailor-payer-name' }):formatMessage({id: 'ga-checkout.new-please-enter-full-name'}),
                  },
                  ({ getFieldValue }) => ({
                    validator: async (rule, value) => {                  
                      if (_.isEmpty(value)) return;
                      let _lang = localStorage.getItem('locale')
                      if (_lang === 'pt-BR' || _lang === 'en-US') {
                        const eleArray = value.split(/[\s\n]/);                      
                        if(_.uniq(eleArray).length !== eleArray.length){
                          return Promise.reject(
                            formatMessage({
                              id: 'ga-checkout.name-repeat-tip',
                            }),
                          );
                        }                        
                      }                   
                    },
                  }),
                ]}
              >
                <Input
                  size="large"
                  maxLength={128}
                  onBlur={e => onBlurCardName(e)}
                />
              </FloatLabel>
            </Col>
          </Row>

          {/* CPF */}
          <myContext.Provider
            value={{
              form,
              isMobileView,
              radioValue,
              showDomain,
              initData,
              resData,
              cashierData,
            }}
          >
            <CPF />
          </myContext.Provider>

          {/* 巴西生日采集（PIX / Boleto）。
              PIX/Boleto 允许 CNPJ，而渠道方明确要求 CNPJ 不采集、不发送生日，
              因此用 shouldUpdate 跟随 cardHolderIdNo 实时判定：11 位 CPF 才展示。
              preserve={false} 让字段卸载时一并清值，避免 CPF→CNPJ 切换后残留旧值被提交。
              KYC 主体是付款人。
              用普通文本框替代 DatePicker，按巴西本地惯例 DD/MM/YYYY，输入数字自动补 /：
              输 21051990 自动格式化为 21/05/1990，maxLength=10，inputMode=numeric 唤起数字键盘。
              满 18 周岁校验仍放 vIndex.onFinish 提交时，不在此处重复。 */}
          {supportBirthDate && cashierData?.birthdaySwitch === true ? (
            <Form.Item
              noStyle
              shouldUpdate={(prev, cur) => prev.cardHolderIdNo !== cur.cardHolderIdNo}
            >
              {({ getFieldValue }) =>
                String(getFieldValue('cardHolderIdNo') || '').replace(/[^0-9]/g, '').length === 11 ? (
                  <Row gutter={20}>
                    <Col span={24}>
                      <FloatLabel
                        extra={<div style={{ marginBottom: 8 }}>{formatMessage({ id: 'ga-checkout.birth-date-hint' })}</div>}
                        form={form}
                        name="birthDate"
                        label={formatMessage({ id: 'ga-checkout.birth-date-label' })}
                        className="ant-form-item-required"
                        floatclassname="h5pc-birth-date-field"
                        preserve={false}
                        validateTrigger="onBlur"
                        placeholder={formatMessage({ id: 'ga-checkout.birth-date-placeholder' })}
                        rules={[
                          {
                            required: true,
                            message: formatMessage({ id: 'ga-checkout.birth-date-required' }),
                          },
                          // 格式 + 有效日期 + 未来日期 + 满 18 周岁，全部失焦校验。
                          // 失焦即校验，用户改完重新失焦会重跑，错误随值更新，不会被钉死。
                          {
                            validator: async (rule, value) => {
                              if (!value) return;
                              if (!/^(\d{2})\/(\d{2})\/(\d{4})$/.test(value)) {
                                return Promise.reject(
                                  formatMessage({ id: 'ga-checkout.birth-date-invalid' }),
                                );
                              }
                              const [d, m, y] = value.split('/').map(Number);
                              const dt = moment(
                                `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`,
                                'YYYY-MM-DD',
                                true,
                              );
                              if (!dt.isValid()) {
                                return Promise.reject(
                                  formatMessage({ id: 'ga-checkout.birth-date-invalid-date' }),
                                );
                              }
                              if (dt.isAfter(moment().endOf('day'))) {
                                return Promise.reject(
                                  formatMessage({ id: 'ga-checkout.birth-date-future' }),
                                );
                              }
                              // 满 18 周岁（付款人主体）。原放 onFinish，错误被钉死，
                              // 改完不重新提交就一直提示；移到此处失焦校验解决。
                              if (dt.isAfter(moment().subtract(18, 'years').endOf('day'))) {
                                return Promise.reject(
                                  formatMessage({ id: 'ga-checkout.birth-date-underage' }),
                                );
                              }
                            },
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          maxLength={10}
                          inputMode="numeric"
                          placeholder={formatMessage({ id: 'ga-checkout.birth-date-placeholder' })}
                          onChange={e => {
                            // 只保留数字，截断到 8 位，第 2/4 位后自动补 /。
                            // 输 21051990 -> 21/05/1990，maxLength=10 含两个 /。
                            let raw = e.target.value.replace(/\D/g, '').slice(0, 8);
                            if (raw.length > 4) {
                              raw = raw.slice(0, 2) + '/' + raw.slice(2, 4) + '/' + raw.slice(4);
                            } else if (raw.length > 2) {
                              raw = raw.slice(0, 2) + '/' + raw.slice(2);
                            }
                            form.setFieldsValue({ birthDate: raw });
                          }}
                        />
                      </FloatLabel>
                    </Col>
                  </Row>
                ) : null
              }
            </Form.Item>
          ) : null}
          <myContext.Provider
            value={{ initData, cashierData, form, radioValue, isMobileView, showDomain }}
          >
            <Address cref={addressRef} type={type}/>
          </myContext.Provider>

          <myContext.Provider value={{ form, cashierData, isMobileView, showDomain }}>
            <Email />
          </myContext.Provider>
          { 
            hasTerms ?
              <div className='pixBol-terms'>
                <Checkbox
                  onChange={() => {
                    setButtonDisabled(!buttonDisabled)
                    sessionStorage.setItem('buttonDisabled', !buttonDisabled)
                  }}
                  checked={!buttonDisabled}
                >
                  {formatMessage({ id: 'ga-checkout.brazil-i-agree-with' })}
                  <a target='_blank' href='https://www.lianlianglobal.com.br/termos-de-uso.html'>
                    {formatMessage({ id: 'ga-checkout.brazil-terms-of-us' })}
                  </a>
                  {formatMessage({ id: 'ga-checkout.brazil-and-the' })}
                  <a target='_blank' href="https://www.lianlianglobal.com.br/politica-de-privacidade.html">
                    {formatMessage({ id: 'ga-checkout.brazil-privacy-policy' })}
                  </a>
                  {formatMessage({ id: 'ga-checkout.brazil-of-lianlian-pay' })}
                </Checkbox>
              </div>
              :
              null
          }
          
          <div className="h5pc-submit">
            <Button
              className="h5pc-submit-btn"
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={buttonDisabled}
            >

              <span className="lock-img" ></span>
              {formatMessage({ id: 'ga-checkout.pay' })} &nbsp;
              {actualPaymentAmount} {actualPaymentCurrency}
            </Button>
          </div>
          {radioValue === 'PIX' && (cashierData?.merchantSourceType === "SAILOR")?<div style={{
            fontSize:'14px',
            padding:'0 20px'
          }}>
            <p style={{
              color:'#00000073',
              lineHeight:'20px',
              marginBottom:'0.5em'
            }}>{formatMessage({id: 'ga-checkout.pix.tip1' })}</p>
            <p style={{
              color:'#00000073',
              lineHeight:'20px',
              marginBottom:'0.5em'
            }}>{formatMessage({id: 'ga-checkout.pix.tip2' })}</p>
            <p style={{
              color:'#00000073',
              lineHeight:'20px',
              marginBottom:'0.5em'
            }}>{formatMessage({id: 'ga-checkout.pix.tip3' })}</p>
          </div> : ""}
        </>
      ) : null}
    </Skeleton>
  );
}

export default injectIntl(PIXBOL);
